import React from "react";
import { RCCAlert, RCCButton, RCCGrid,  RCCIcon, RCCProgress, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import Photo from "src/components/Photo";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import formatDate from "src/utils/formatDate";
import formatNumber from "src/utils/formatNumber";
import { v4 } from "uuid";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { IDashboardOkrsData } from "../interface";
import { Container, Span } from "./styles";

const DashboardCardsOKRWithKRs: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate, currentLanguage } = useTranslation();
	const {REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY} = process.env;
	
	const { data, loading } = card?.daa002Idorigem ?  useEffectFetchData<IDashboardOkrsData> (
		"DashboardOKRs/SelectOkrWithKRs", 
		{ 	id: card?.daa002Idorigem }
	): { data: undefined, loading: true };

	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Detalhe OKR com Resultado Chave") }
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to="/okr/panel">
					<RCCTooltip
						text={translate("Painel de OKR")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="strategicPlanning"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>

			<DefaultBody maxHeight={420}>
				{!card?.daa002Idorigem ? (
					<RCCAlert 
						title={translate("Atenção")}
						description={translate("É necessário selecionar um OKR")}
					/>
				): (
					<>
						{data && (
							<>
								<RCCGrid container item justifyContent="space-between" alignItems="center">
									<Title color="purple">{data.oka001Titulo}</Title>
									<Container>
										<RCCIcon name="calendar" size={16} color="var(--default-color-font)" />
										<Span>
											{data.oka001Periodo ? data.oka001Periodo : `${formatDate(data.oka001Dtinicio, currentLanguage)} - ${formatDate(data.oka001Dtfim, currentLanguage)}`}
										</Span>
									</Container>
								</RCCGrid>
								<RCCProgress 
									layout="line"
									value={data.percent}
									color={data.colorGraph && data.colorGraph !== null && data.colorGraph !== "" ? `#${data.colorGraph}` : undefined}
								/> 
								<hr />
								{data.oktbb001001 && data.oktbb001001.length > 0 && data.oktbb001001.map((okb001) => (
									<RCCGrid container item key={v4()}>
										<RCCGrid container item sm={10} direction="column">
											<Title color="defaultColor" bold>
												KR: {okb001.okb001Titulo}
												{okb001.checkInFrequency && okb001.checkInFrequency !== null && okb001.checkInFrequency !== "" && (
													<>
														{okb001.checkInFrequency === "Hoje" && (
															<RCCTooltip
																color="yellow"
																text={translate("Hoje")}
															>
																<RCCIcon name="exclamationCircle" size={12} color="var(--yellow)"/>
															</RCCTooltip>
														)}
														{okb001.checkInFrequency.substring(0, 8) === "Atrasado" && (
															<RCCTooltip
																color="red"
																text={translate("Atrasado")}
															>
																<RCCIcon name="exclamationCircle" size={12} color="var(--red)" />
															</RCCTooltip>
														)}
														{okb001.checkInFrequency.substring(0, 7) === "Próximo" && (
															<RCCTooltip
																color="yellow"
																text={translate("Próximo")}
															>
											 					<RCCIcon name="exclamationCircle" size={12} color="var(--yellow)" />
															</RCCTooltip>
														)}
													</>
												)}
											</Title>
											<Container>
												<Photo 
													name={okb001.okb001Efa005Nome}
													link={okb001.okb001Efa005Imagem && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${okb001.okb001Efa005Imagem}`}
													hover={false}
												/>
												<Span>
													{okb001.okb001Efa005Nome}
												</Span>
											</Container>
											<RCCGrid container item justifyContent="space-between" alignItems="center">
												<Span style={{width: "50%" }}>
													{translate("Valor inicial")}: {formatNumber(okb001.okb001Valorinicial, currentLanguage)}
												</Span>
												<Span style={{width: "30%" }}>
													{translate("Realizado")}: {formatNumber(okb001.realizedValuesCheckIn, currentLanguage)}
												</Span>
												<Span style={{width: "20%", display: "flex", justifyContent: "flex-end" }}>
													{translate("Meta")}: {formatNumber(okb001.okb001Meta, currentLanguage)}
												</Span>
											</RCCGrid>
										</RCCGrid>
										<RCCGrid container item sm={2} alignItems="center" justifyContent="center">
											<RCCProgress 
												layout="circle"
												width="60px"
												value={okb001.percent || 0}
												color={okb001.colorGraph && okb001.colorGraph !== null && okb001.colorGraph !== "" ? `#${okb001.colorGraph}` : undefined}
											/>
										</RCCGrid>
										<hr />
									</RCCGrid>
								))}
							</>
						)}
					</>
				)}
				
			</DefaultBody>
		</DefaultContainer>
	);};

export default DashboardCardsOKRWithKRs;
